export const STEPS = {
  lead: '/play-ao-vivo/',
  plan_selection: '/steps/planos-play-aovivo/',
  plan_selection_play: '/steps/planos-play/',
  plan_selection_anniversary: '/steps/planos-aovivo-aniversario/',
  plan_selection_live: '/steps/planos-play-aovivo/',
  hotmart_payment_started: '/steps/pagamento/',
  prospect_start_monday: '/segunda-comeco/',
  plan_selection_start_monday: '/steps/planos-segunda-comeco/',
  finish_start_monday: '/segunda-comeco/bem-vindo/'
}
